
import { aashto, findZr, rigidAashto } from '@/modules/design/lib/calculations/calculationUtils';
import { IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';
import { IConcreteOutputObj, OutputObj, SnOutput } from '@/modules/design/interfaces/shared';
import { IConcreteDesignImperial } from '@/modules/design/interfaces/newConcrete';

// Project Type: New-Asphalt
export const calculateRigidDesign = function (scenario: IConcreteDesignImperial): IConcreteOutputObj | null {
  const CeilHalf = function (amount: number) {
    const temp_amount = Math.ceil(amount);
    const compare = temp_amount - amount;
    let final_amount = temp_amount;
    if (compare > 0.5) {
      final_amount = temp_amount - 0.5;
    }
    return final_amount;
  };


  // These variables were part of the rigidAashto call signature but they're not used in the actual calc??
  // Scenario god object is primary source of data.
  //
  // TODO: Move towards decoupling the calculation from the scenario object

  const reliability = scenario.reliabilityLevel;
  const zr = findZr(reliability || 50);
  const esal = scenario.totalDesignEsals || 0;
  const std_error = scenario.standardError || 0;
  const pt = scenario.terminalServiceability || 0;
  const sc = scenario.ruptureModulus_psi || 0;
  const cd = scenario.drainageFactor || 0;
  const j = scenario.loadTransferCoefficient || 0;
  const ec = scenario.elasticModulus_psi || 0;
  const k = scenario.subgradeReactionModulus_psiPerIn || 0;
  const delta_psi = Math.abs(scenario.deltaServiceability || 0);

  // Perform the calc
  const results = rigidAashto(scenario, esal, zr, std_error, delta_psi, pt, sc, cd, j, ec, k);

  const d_design = results.D;

  const obj: IConcreteOutputObj = {
    layers: [
      {
        label: 'Rigid (JPCP)',
        depth: d_design,
        type: 'pcc',
        showLayer: d_design > 0,
      },
      {
        label: 'Base',
        depth: Number((scenario.baseThickness_in || 0).toFixed(2)),
        type: 'base',
        showLayer: (scenario.baseThickness_in || 0) > 0,
      },
    ],
    warning: null,
    errors: null,
    layerCalculations: results,
  };


  if (results.D <= 6.0000001) {
    obj.errors = 'Your input values resulted in thickness that is too low and does not meet current AASHTO standards.  Use AASHTO minimum recommended thickness of 6 inches.';
  } else if (results.D >= 14.99999) {
    obj.errors = 'Your input values resulted in thickness that is too large and does not meet current AASHTO standards of the maximum thickness of 15 in.  Please consider not using rigid design.';
  }

  return obj;
};
